module.exports = __webpack_public_path__ + "img/image24.82032250.webp";